import React, { useRef, useEffect } from 'react'
import { Button } from 'carbon-components-react'
import UrlBuilder from '../shared/urlBuilder/UrlBuilder'
import IconCheckMarkHeader from '../../globals/images/icon-checkmark-header.svg'

export default function RegisterConfirmationPage ( )  {

    const divElement = useRef( null )

    const logInUrl = () => {
        return process.env.REACT_APP_REDIRECT_TO_ACCOUNT_OVERVIEW 
    }

    useEffect( ()=>{
        divElement?.current?.focus() 
    } )

    const title = 'Sign Up Complete'
    return (
        <>
            <main className="c-main">
                <div className="os-container--max-width">
                    <div className="c-form-card">
                        <div className="c-form-card__container custom-card-container" >
                            <p className="o-heading-alpha mb-8 pb-0 pl-9" tabIndex={ 0 } ref={ divElement }>
                                <img src={ IconCheckMarkHeader } alt="Confirmation" className="c-svg-header-icon"/>
                                { title } 
                            </p>
                            <div className="u-text-center mb-12 custon-register-button">
                                <Button className='c-btn c-btn--primary register-button custom-register-button' href={ UrlBuilder( { url: logInUrl(), buildURL: true } ) } type="submit" tabIndex={ 0 }>Sign In</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}